import "../css/CategorySection.css";
import CategoryGridWeb from "./AnimaliaCategorySection";
import CategoryGridMobile from "./AnimaliacatMobile";

const CategorySection = () => {
  return (
    <>
      <div className="mobile-only">
        <CategoryGridMobile />
      </div>

      <div className="web-only">
        <CategoryGridWeb />
      </div>
    </>
  );
};

export default CategorySection;
